export const UPLOAD_SOURCE = 'upload'

export const importRunStatus = {
  Running: 1,
  Success: 2,
  Partial: 3,
  Failed: 4,
  Validated: 5
}

export const IMPORT_RUN_STATUS_OPTIONS = [
  { id: importRunStatus.Running, name: 'Running' },
  { id: importRunStatus.Success, name: 'Success' },
  { id: importRunStatus.Partial, name: 'Partial' },
  { id: importRunStatus.Failed, name: 'Failed' },
  { id: importRunStatus.Validated, name: 'Validated' }
]

export const importRowOutcome = {
  Pending: 1,
  Imported: 2,
  Failed: 3,
  Reconciled: 4
}

export const IMPORT_ROW_OUTCOME_OPTIONS = [
  { id: importRowOutcome.Pending, name: 'Pending' },
  { id: importRowOutcome.Imported, name: 'Imported' },
  { id: importRowOutcome.Failed, name: 'Failed' },
  { id: importRowOutcome.Reconciled, name: 'Reconciled' }
]

const importRunStatusColors = {
  [importRunStatus.Running]: { color: 'blue', dark: true },
  [importRunStatus.Success]: { color: 'green', dark: true },
  [importRunStatus.Partial]: { color: 'orange', dark: true },
  [importRunStatus.Failed]: { color: 'red', dark: true },
  [importRunStatus.Validated]: { color: 'teal', dark: true }
}

export const importRunStatusAttrs = (statusId) => importRunStatusColors[statusId] || { color: 'grey lighten-2', dark: false }

const importRowOutcomeColors = {
  [importRowOutcome.Pending]: { color: 'grey', dark: true },
  [importRowOutcome.Imported]: { color: 'green', dark: true },
  [importRowOutcome.Failed]: { color: 'red', dark: true },
  [importRowOutcome.Reconciled]: { color: 'blue-grey', dark: true }
}

export const importRowOutcomeAttrs = (outcomeId) => importRowOutcomeColors[outcomeId] || { color: 'grey lighten-2', dark: false }
